import script from "./WhiteList2fa.vue?vue&type=script&lang=ts&setup=true"
export * from "./WhiteList2fa.vue?vue&type=script&lang=ts&setup=true"

import "./WhiteList2fa.vue?vue&type=style&index=0&id=fe8817a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe8817a2"]])

export default __exports__